<template>
  <div class="wrapper">
    <parallax
      class="section page-header services-header header-filter"
      :style="headerStyle"
    >
      <div class="overlay"></div>
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-70 md-small-size-70 md-xsmall-size-100"
          >
            <h1 class="title">NUESTROS SERVICIOS</h1>
            <div class="md-layout md-gutter list-container ">
              <div
                class="md-layout-item md-medium-size-50 md-small-size-100 md-xsmall-size-100"
              >
                <h4>Sistemas de acueducto y alcantarillado</h4>
                <hr />
                <ul>
                  <li>Sistemas de Bombeo</li>
                  <li>Reposición de Redes</li>
                  <li>Sistemas de Redes Contra Incendios</li>
                  <li>Reposición de Válvulas</li>
                  <li>Instalación de Hidrantes</li>
                  <li>Sistemas de Macro Medición</li>
                  <li>
                    Suministro de Válvulas y Accesorios en HD y Acero al Carbón
                  </li>
                  <li>Suministro de Tuberías</li>
                </ul>
              </div>

              <div
                class="md-layout-item image-text md-medium-size-50 md-small-size-100 md-xsmall-size-100"
              >
                <h4>
                  ⠀<br />
                  Montajes
                </h4>
                <hr />
                <ul>
                  <li>Líneas de biogás</li>
                  <li>Líneas de impulsión</li>
                  <li>Viaductos</li>
                  <li>Estructuras y puente grúas</li>
                  <li>Montajes sobre tuberías ccp</li>
                </ul>
              </div>
            </div>
            <br />
            <md-button to="/contactanos" class=" md-lg">CONTÁCTANOS</md-button>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto text-center"
            >
              <h2 class="title text-center">¿Qué ofrecemos?</h2>
            </div>
          </div>
          <Servicio
            title="SUMINISTRO E INSTALACION DE TUBERIAS EN HIERRO DUCTIL, ACERO CARBON, ACERO INOXIDABLE, POLIETILENO DE ALTA DENSIDAD, CCP, PVC Y GRP."
            content="
            Diseñamos, suminístramos e instalamos redes para aprovisionamiento de agua tratada, cruda y alcantarillado en proyectos de infraestructura pública y privada.
            "
            imageOne="instalacion-tuberias (1).jpg"
            locationOne="Yumbo - Valle del Cauca"
            imageTwo="instalacion-tuberias (2).jpg"
            locationTwo="Cali (Valle del Lili) - Valle del Cauca"
            imageThree="instalacion-tuberias (3).jpg"
            locationThree="Yumbo - Valle del Cauca"
            serviceIcon="suministro-ico.png"
          ></Servicio>
          <Servicio
            title="SUMINISTRO E INSTALACION DE UNIONES, ACCESORIOS Y NIPLES EN ACERO CARBON."
            content="
            Somos fabricantes de uniones en acero carbón
            para todo tipo de tuberías. su uso va desde la unión entre
            tuberías, accesorios y válvulas. Hasta las reparaciones de daños en Redes.
            Tenemos diseños de uniones en diametros desde 12'' hasta 56'', no siendo
            una limitante el diámetro, fabricamos según la necesidad de nuestros clientes,
            y para materiales desde tuberías de HD, HF, AC, ACERO, PVC, GRP.

            Somos fabricantes de accesorios y nipleria en acero carbón, HD, desde 2'' hasta
            el diámetro requerido en el proyecto.
            "
            imageOne="uniones-nipples (1).jpg"
            locationOne="Pasto - Nariño"
            imageTwo="uniones-nipples (2).jpg"
            locationTwo="Buenaventura - Valle del Cauca"
            imageThree="uniones-nipples (3).jpg"
            locationThree="Cali - Valle del Cauca"
            serviceIcon="instalacion-ico.png"
          ></Servicio>
          <Servicio
            title="SISTEMAS DE MACROMEDICIÓN"
            content=""
            imageOne="macromedicion (1).jpg"
            locationOne="Cali - Valle del Cauca"
            imageTwo="macromedicion (2).jpg"
            locationTwo="Cali - Valle del Cauca"
            imageThree="macromedicion (1).jpg"
            locationThree="Cali - Valle del Cauca"
            serviceIcon="macromedicion-ico.png"
          ></Servicio>
          <Servicio
            title="REPARACIÓN DE DAÑOS EN TUBERÍAS DE REDES DE ACUEDUCTO"
            content="Contamos con amplia experiencia en acueducto para realizar las reparaciones sobre todo tipo de tuberías en redes de acueducto enterradas o visibles. Actuando en el menor tiempo posible y generando el menor impacto en la comunidad  o sistema productivo.
            "
            imageOne="reparacion (1).jpg"
            locationOne="Cali - Valle del Cauca"
            imageTwo="reparacion (2).jpg"
            locationTwo="Cali - Valle del Cauca"
            imageThree="reparacion (3).jpg"
            locationThree="Cali - Valle del Cauca"
            serviceIcon="reparacion-ico.png"
          ></Servicio>
          <Servicio
            title="SUMINISTRO E INSTALACION DE SISTEMAS DE BOMBEO, VARIADORES DE VELOCIDAD, ARRANCADORES SUAVES, REDES CONTRA INCENDIOS. "
            content="
           Realizamos el diseño e instalación de los sistemas  de bombeo y abastecimiento de agua tanto de empresas de servicios públicos como privadas, garantizando óptimos productos para sus necesidades. "
            imageOne="sistemas-bombeo (1).jpg"
            locationOne="Cali - Valle del Cauca"
            imageTwo="sistemas-bombeo (2).jpg"
            locationTwo="Planta Mijitayo - Pasto - Nariño"
            imageThree="uno.jpg"
            locationThree="Cali - Valle del Cauca"
            serviceIcon="bombeo-ico.png"
          ></Servicio>
          <Servicio
            title="REPOSICION DE REDES. "
            content="
            "
            imageOne="reposicion-redes (1).jpg"
            locationOne="Cali - Valle del Cauca"
            imageTwo="reposicion-redes (2).jpg"
            locationTwo="Planta Mijitayo - Pasto - Nariño"
            imageThree="reposicion-redes (3).jpg"
            locationThree="Cali - Valle del Cauca"
            serviceIcon="reposicion-ico.png"
          ></Servicio>
          <Servicio
            title="SISTEMAS DE REDES CONTRA INCENDIOS"
            content="
            Utilizamos acero carbón en la fabricación de nuestros productos industriales, ya que posee gran versatilidad y permite cumplir con las necesidades de cada proyecto en particular. Fabricamos uniones tipo dresser hasta 66’’ o más si el proyecto lo requiere, uniones de desmontaje autoportantes bajo norma ISO o AMSI hasta 66’’, al igual que accesorios en diámetros requeridos según el proyecto.
            "
            imageOne="uno.jpg"
            locationOne="Cali - Valle del Cauca"
            imageTwo="dos.jpg"
            locationTwo="Cali - Valle del Cauca"
            imageThree="tres.jpg"
            locationThree="Facatativá - Cundinamarca"
            serviceIcon="incendios-ico.png"
          ></Servicio>
          <Servicio
            title="REPOSICIÓN DE VALVULAS"
            content=" "
            imageOne="valvulas.jpg"
            locationOne="Cali - Valle del Cauca"
            imageTwo="valvulas2.jpg"
            locationTwo="Cali - Valle del Cauca"
            imageThree="reparacion (3).jpg"
            locationThree="Cali - Valle del Cauca"
            serviceIcon="valvulas-ico.png"
          ></Servicio>
          <Servicio
            title="FABRICACION DE ESTRUTURA METALICA, VIADUCTOS, BARCAZAS FLOTANTES."
            content="
            Relizamos diseños, suministros e instalaciones de estructuras metálicas, viaductos y barcazas flotantes con los cuales creamos la infraestructura adecuada para el suministro de agua según las necesidades de las empresas prestadores de servicios públicos o privados.
            "
            imageOne="viaductos-y-barcazas (1).jpg"
            locationOne="Cali - Valle del Cauca"
            imageTwo="viaductos-y-barcazas (2).jpg"
            locationTwo="El guamo - Bolívar"
            imageThree="viaductos-y-barcazas (3).jpg"
            locationThree="Facatativá - Cundinamarca"
            serviceIcon="barcazas-ico.png"
          ></Servicio>
          <Servicio
            title="LINEAS DE BIOGAS"
            content="
            "
            imageOne="biogas.png"
            locationOne="Cali - Valle del Cauca"
            imageTwo="biogas.png"
            locationTwo="Cali - Valle del Cauca"
            imageThree="biogas.png"
            locationThree="Cali - Valle del Cauca"
            serviceIcon="biogas-ico.png"
          ></Servicio>
        </div>
      </div>
      <div class="section section-contacts">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto">
              <h2 class="text-center title">Déjanos asesorarte</h2>
              <h4 class="text-center description">
                Describe detalles sobre tu proyecto o necesidad, responderemos
                en un par de horas.
              </h4>
              <form class="contact-form" @submit.prevent="sendEmail">
                <div class="md-layout">
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Nombre</label>
                      <md-input v-model="name" type="text"></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Correo</label>
                      <md-input v-model="email" type="email"></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Ciudad</label>
                      <md-input v-model="ciudad" type="text"></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Teléfono</label>
                      <md-input v-model="telefono" type="tel"></md-input>
                    </md-field>
                  </div>
                </div>
                <md-field maxlength="5">
                  <label>Mensaje</label>
                  <md-textarea v-model="message"></md-textarea>
                </md-field>
                <div class="md-layout">
                  <div class="md-layout-item md-size-33 mx-auto text-center">
                    <md-button type="submit" class="md-success"
                      >Enviar mensaje</md-button
                    >
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Servicio from "./components/Servicio";

export default {
  bodyClass: "servicios-page",
  components: {
    Servicio
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/servicios.jpg")
    },
    teamImg1: {
      type: String,
      default: require("@/assets/img/faces/avatar.jpg")
    },
    teamImg2: {
      type: String,
      default: require("@/assets/img/faces/christian.jpg")
    },
    teamImg3: {
      type: String,
      default: require("@/assets/img/faces/kendall.jpg")
    }
  },
  data() {
    return {
      name: null,
      email: null,
      message: null,
      telefono: null,
      ciudad: null
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  },
  methods: {
    sendEmail: function(e) {
      var data = this;
      var template_params = {
        reply_to: data.email,
        from_name: data.name,
        to_name: "Ingenieria y soluciones civiles",
        telefono: data.telefono,
        ciudad: data.ciudad,
        message_html: data.message
      };

      var service_id = "isc";
      var template_id = "template_f2p69cBy";
      emailjs.send(service_id, template_id, template_params).then(
        result => {
          data.name = null;
          data.email = null;
          data.message = null;
          alert("tu mensaje ha sido enviado");
        },
        error => {
          alert("No se pudo enviar tu mensaje, intenta de nuevo");
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
</style>
